import React from "react";

import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/blogs/footer.js";

const Footer = () => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.footerContainer }>
			<Typography
				title = { "Copyright @ Rooter Sports Technologies 2022, All Rights Reserved" }
			/>
		</div>
	);
};

export default Footer;